import React from "react";
import MainLayout from "./MainLayout";
import Specialties from "../common/OnBoarding/OnBoardingSpecialties";

const EduSpec = (props) => <MainLayout component={Specialties} />;

export default EduSpec;
